import { FC } from 'react';
import { Paper, PaperProps } from '@mantine/core';

import classes from './ScrollSection.module.scss';

interface ScrollSectionProps extends PaperProps {
  children: React.ReactNode;
  withNav?: boolean;
  withStickyHeader?: boolean;
}

const ScrollSection: FC<ScrollSectionProps> = ({
  children,
  withNav = true,
  withStickyHeader = false,
  ...props
}) => {
  const offset = withNav ? 9.9 : 6.25;
  const baseOffset = withNav ? 9.25 : 6.25;

  return (
    <Paper
      radius="md"
      withBorder
      pb={{ md: 'lg', base: 'md' }}
      pt={withStickyHeader ? 0 : { md: 'lg', base: 'md' }}
      className={classes.scrollSection}
      pos={{ md: 'sticky', base: 'relative' }}
      h={{
        md: `calc(100vh - ${offset}rem)`,
        base: `calc(100dvh - ${baseOffset}rem)`,
      }}
      {...props}
    >
      {children}
    </Paper>
  );
};

export default ScrollSection;
